import React from "react";

// Sign-in security policy fields. The Founder role is always required while the gate is on (the server enforces it).
export default function PolicyForm({ form, setForm, roles, disabled }) {
  const set = (k, v) => setForm({ ...form, [k]: v });
  const toggleRole = (key) => set("required_roles", form.required_roles.includes(key)
    ? form.required_roles.filter((r) => r !== key) : [...form.required_roles, key]);
  return (
    <fieldset className="space-y-4" disabled={disabled} data-testid="mfa-policy-form">
      <label className="flex items-center gap-3 min-h-[44px] cursor-pointer">
        <input type="checkbox" role="switch" aria-checked={form.enrollment_required} checked={form.enrollment_required}
          onChange={(e) => set("enrollment_required", e.target.checked)} className="w-5 h-5 accent-erf-gold" data-testid="mfa-policy-enabled" />
        <span className="font-nav font-semibold">Require two-step sign-in for the roles below</span>
      </label>
      <label htmlFor="mfa-policy-grace" className="block text-sm">Grace period (days to set it up after the switch is turned on)
        <input id="mfa-policy-grace" type="number" min={0} max={90} value={form.grace_days}
          onChange={(e) => set("grace_days", Math.max(0, Math.min(90, Number(e.target.value) || 0)))}
          className="block mt-1 min-h-[44px] w-28 rounded border border-erf-borderCream px-3" data-testid="mfa-policy-grace" />
      </label>
      <div role="group" aria-labelledby="mfa-policy-roles-title">
        <p id="mfa-policy-roles-title" className="text-sm font-semibold">Roles that must use two-step sign-in</p>
        <ul className="grid sm:grid-cols-2 gap-1 mt-1" data-testid="mfa-policy-roles">
          {roles.map((r) => {
            const locked = r.always && form.enrollment_required;
            return (
              <li key={r.key}>
                <label className="flex items-center gap-3 min-h-[44px] cursor-pointer text-sm">
                  <input type="checkbox" checked={locked || form.required_roles.includes(r.key)} disabled={locked}
                    onChange={() => toggleRole(r.key)} className="w-5 h-5 accent-erf-gold" data-testid={`mfa-policy-role-${r.key}`} />
                  {r.label}{locked ? " (always required)" : ""}
                </label>
              </li>
            );
          })}
        </ul>
      </div>
    </fieldset>
  );
}
